export default __webpack_public_path__ + "static/media/green_energy.78956a53.svg";